/* eslint-disable camelcase */
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var latePaymentsColumns = [{
  name: 'Кр. посредник',
  value: 'franchisee_name',
  width: '110px'
}, {
  name: 'Офис',
  value: 'office_name',
  width: '110px'
}, {
  name: 'Кр. номер',
  value: 'number',
  width: '110px'
}, {
  name: 'Проср. главници',
  render: function render(_ref) {
    var late_principal = _ref.late_principal,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "late_principal"
    }, late_principal, " ", currency);
  }
}, {
  name: 'Проср. лихви',
  render: function render(_ref2) {
    var late_interest = _ref2.late_interest,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "late_interest"
    }, late_interest, " ", currency);
  }
}, {
  name: 'Проср. такси',
  render: function render(_ref3) {
    var late_fees = _ref3.late_fees,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "late_fees"
    }, late_fees, " ", currency);
  }
}, {
  name: 'Общо проср.',
  render: function render(_ref4) {
    var total_late = _ref4.total_late,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_late"
    }, total_late, " ", currency);
  }
}];